module.exports = __webpack_public_path__ + "img/马兜铃.e4737d2c.jpg";